import TopicsCard from '../../api/topics_card';
const topicsCard = new TopicsCard();

const topicsCardModule = {
    namespaced: true,
    state: {
        loading: false,
        cardsTopics: [],
        totalCardsTopics: 0,
        topicsCardLookups: [],
    },
    getters: {
        cardsTopics: (state) => state.cardsTopics,
        totalCardsTopics: (state) => state.totalCardsTopics,
        topicsCardLookups: (state) => state.topicsCardLookups,
        loading: (state) => state.loading,
    },
    mutations: {
        SET_LOADING: (state, loading) => {
            state.loading = loading;
        },
        SET_CARDS_TOPICS: (state, data) => {
            state.cardsTopics = data;
        },
        SET_TOTAL_CARDS_TOPICS: (state, count) => {
            state.totalCardsTopics = count;
        },
        SET_TOPICS_CARD_LOOKUPS: (state, data) => {
            state.topicsCardLookups = data;
        },
    },
    actions: {
        GetCardsTopics({ commit }, payload) {
            const query = (payload && payload.query) || {};
            return new Promise((resolve, reject) => {
                commit('SET_LOADING', true);
                topicsCard.list(query).then(response => {
                    if (response) {
                        const data = Array.isArray(response) ? response : (response.topicsCards || response.topics_cards || response.data || []);
                        commit('SET_CARDS_TOPICS', data);
                        commit('SET_TOTAL_CARDS_TOPICS', response.total || response.count || data.length || 0);
                    }

                    commit('SET_LOADING', false);
                    resolve(response);
                }).catch(error => {
                    commit('SET_LOADING', false);
                    reject(error);
                });
            });
        },
        CreateCardsTopic({ commit }, payload) {
            return new Promise((resolve, reject) => {
                commit('SET_LOADING', true);
                topicsCard.store(payload).then(response => {
                    commit('SET_LOADING', false);
                    resolve(response);
                }).catch(error => {
                    commit('SET_LOADING', false);
                    reject(error);
                });
            });
        },
        DeleteCardsTopic({ commit }, id) {
            return new Promise((resolve, reject) => {
                commit('SET_LOADING', true);
                topicsCard.delete(id).then(response => {
                    commit('SET_LOADING', false);
                    resolve(response);
                }).catch(error => {
                    commit('SET_LOADING', false);
                    reject(error);
                });
            });
        },
        GetTopicsCardLookups({ commit }) {
            return new Promise((resolve, reject) => {
                // commit('SET_LOADING', true); // Optional: might not want to show full loading for lookups
                topicsCard.lookups().then(response => {
                    if (response) {
                        const data = Array.isArray(response) ? response : (response.topicsCards || response.topics_cards || response.data || []);
                        commit('SET_TOPICS_CARD_LOOKUPS', data);
                    }
                    // commit('SET_LOADING', false);
                    resolve(response);
                }).catch(error => {
                    // commit('SET_LOADING', false);
                    reject(error);
                });
            });
        },
    }
};

export default topicsCardModule;
